import { BasePlugin } from '../../core/base-plugin';
import { BehaviorData } from './types';
import { debounce } from '../../utils/debounce';

export class BehaviorPlugin extends BasePlugin {
  public name = 'behavior';
  private clickHandler: (event: MouseEvent) => void;

  constructor() {
    super();
    this.clickHandler = debounce(this.handleClick.bind(this), 300);
  }

  public init(): void {
    this.monitorPV();
    document.addEventListener('click', this.clickHandler, true);
  }

  public destroy(): void {
    if (this.clickHandler) {
      document.removeEventListener('click', this.clickHandler, true);
    }
  }

  private monitorPV(): void {
    const data: BehaviorData = {
      type: 'behavior',
      subType: 'pv',
      url: window.location.href,
      referer: document.referrer,
    };
    this.report?.(data);
  }

  private handleClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const data: BehaviorData = {
      type: 'behavior',
      subType: 'click',
      path: this.getElementPath(target),
    };
    this.report?.(data);
  }

  private getElementPath(element: HTMLElement): string {
    if (!element || !element.tagName) return '';
    
    const path = [] as string[];
    let currentElement: HTMLElement | null = element;
    
    while (currentElement) {
      let selector = currentElement.tagName.toLowerCase();
      if (currentElement.id) {
        selector += `#${currentElement.id}`;
      } else if (currentElement.className) {
        selector += `.${currentElement.className.split(' ').join('.')}`;
      }
      path.unshift(selector);
      currentElement = currentElement.parentElement;
    }
    
    return path.join(' > ');
  }
} 